import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import lodash from 'lodash';

import { ClubsService } from './clubs.service';
import { selectedClub, State as ClubState } from './clubs.reducer';
import {
  attachFiles,
  attachPhotos,
  removePhoto,
  removeFile,
  selectClub,
  unselectClub,
  loadClubPhotos,
  loadClubFiles,
  loadResources,
  postResource,
  likeResource,
  updateResource,
  deleteResource,
  saveResource,
  unsaveResource
} from './clubs.actions';
import { Club, File, Photo } from './club.model';
import { map } from 'rxjs/operators';
import { IMessage } from 'src/app/shared/components/message/message.component';
import { IPost, IPostForm } from 'src/app/shared/models/post';

@Injectable({
  providedIn: 'root'
})
export class ClubFacade {
  photos$ = this.store.pipe(select(selectedClub())).pipe(
    map((_) => (_.photos ? Object.values(_.photos) : [])),
    map((_) => lodash.orderBy(_, ['id'], ['desc']))
  );

  files$ = this.store.pipe(select(selectedClub())).pipe(
    map((_) => (_.files ? Object.values(_.files) : [])),
    map((_) => lodash.orderBy(_, ['id'], ['desc']))
  );

  resources$ = this.store.pipe(select(selectedClub())).pipe(
    map((_) => (_.resources ? Object.values(_.resources) : [])),
    map((_) => lodash.orderBy(_, ['id'], ['desc']))
  );
  resourcesStatus$ = this.store
    .pipe(select(selectedClub()))
    .pipe(map((_) => _.resources_status));

  constructor(
    private clubService: ClubsService,
    private store: Store<ClubState>
  ) {}

  selectClub(club: Club) {
    this.store.dispatch(selectClub({ club }));
  }

  unselectClub() {
    this.store.dispatch(unselectClub());
  }

  sendInvitation(id: number, email: string) {
    return this.clubService.sendInvitation(id, email);
  }

  loadMediaPhotos(id: number, page: number) {
    this.store.dispatch(loadClubPhotos({ id, page }));
  }

  attachPhotos(id: number, photos: Photo[]) {
    this.store.dispatch(attachPhotos({ id, photos }));
  }

  removePhoto(id: number, photoID: number) {
    this.store.dispatch(removePhoto({ id, photoID }));
  }

  loadMediaFiles(id: number, page: number) {
    this.store.dispatch(loadClubFiles({ id, page }));
  }

  attachFiles(id: number, files: File[]) {
    this.store.dispatch(attachFiles({ id, files }));
  }

  removeFile(id: number, fileID: number) {
    this.store.dispatch(removeFile({ id, fileID }));
  }

  loadResources(id: number, page: number) {
    this.store.dispatch(loadResources({ id, page }));
  }

  postResource(id: number, message: IMessage) {
    this.store.dispatch(postResource({ id, message }));
  }

  likeResource(id: number, resourceID: number) {
    this.store.dispatch(likeResource({ id, resourceID }));
  }

  updateResource(id: number, resourceID: number, post: IPostForm) {
    this.store.dispatch(updateResource({ id, resourceID, post }));
  }

  complainToResource(resourceID: number) {
    return this.clubService.complainToResource(resourceID);
  }

  deleteResource(id: number, resourceID: number) {
    this.store.dispatch(deleteResource({ id, resourceID }));
  }

  saveResource(id: number, resourceID) {
    this.store.dispatch(saveResource({ id, resourceID }));
  }

  unsaveResource(id: number, resourceID) {
    this.store.dispatch(unsaveResource({ id, resourceID }));
  }
}
